import { useEffect, useRef } from 'react'
import classes from './ChatWidget.module.scss'
import FeatureModal from './FeatureModal'
import { ChatPromoVideo } from './types'

interface Props {
  video: ChatPromoVideo
  onClose: () => void
}

/**
 * Panel içi tanıtım oynatıcısı. `preload='none'`: modal açılmadan dosyaya (~79 MB) hiç
 * dokunulmaz, açıldığında da yalnız kullanıcı oynat'a basınca akış başlar. `playsInline` mobilde
 * tam ekrana zorlamayı engeller; modal kapanırken oynatma durdurulur ve indirme iptal edilir.
 * Oynatıcı çalışmazsa (kodek/tarayıcı) kullanıcı videoyu yeni sekmede açabilir.
 */
export default function PromoVideoModal({ video, onClose }: Props) {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const element = videoRef.current
    return () => {
      if (!element) return
      // Kapanışta akışı kes: aksi halde tarayıcı arka planda indirmeyi sürdürebiliyor.
      element.pause()
      element.removeAttribute('src')
      element.load()
    }
  }, [])

  return (
    <FeatureModal
      titleId='chat-promo-video-title'
      title={video.title}
      description='Kısa tanıtım videosu — B2B sitemizin öne çıkan özellikleri.'
      onClose={onClose}
    >
      <div className={classes.promoVideoPlayer}>
        <video
          ref={videoRef}
          className={classes.promoVideoElement}
          src={video.url}
          poster={video.posterUrl ?? undefined}
          controls
          playsInline
          preload='none'
          data-modal-initial-focus
        >
          Tarayıcınız video oynatmayı desteklemiyor.
        </video>
        <a className={classes.promoVideoExternal} href={video.url} target='_blank' rel='noopener noreferrer'>
          Videoyu yeni sekmede aç
        </a>
      </div>
    </FeatureModal>
  )
}
